import { Button, Disclaimer, Typography } from '@libs/components';
import styled from 'styled-components';
import AssetRow from '../asset-row/AssetRow';
import IconPairWithDivider from '../icon-pair-with-divider/IconPairWithDivider';

export const Full = styled.div`
  flex: 1;
  margin-bottom: 2rem;
`;

export const Container = styled.div`
  padding: 2rem 2rem;
  ${({ theme }) => theme.media.tablet`
  padding: 2rem 3.6rem;

  `};
`;
export const BorderBox = styled.div`
  padding: 0.4rem;
  border: 1px solid ${({ theme }) => theme.colors.borders.default};
  border-radius: ${({ theme }) => theme.borderRadius.x5};
`;

export const AssetsContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
  padding: 0 2rem;
`;

export const Separator = styled.div`
  position: relative;
  height: 0.05rem;
  background-color: ${({ theme }) => theme.colors.borders.default};
`;
export const IconContainer = styled.div`
  display: flex;

  top: -1.4rem;
  left: 0;
  right: 0;
  position: absolute;
  align-items: center;
  justify-content: center;
`;
export const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotate(90deg);
  width: 3.2rem;
  height: 3.2rem;
  border-radius: ${({ theme }) => theme.borderRadius.x4};
  background-color: ${({ theme }) => theme.colors.surface.tertiary};
`;

export const DetailsWrapper = styled.div`
  padding: 0.4rem 2rem 0;
`;

export const DetailRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 1.6rem 0;
  &:last-child {
    border-top: 0.5px solid ${({ theme }) => theme.colors.borders.default};
  }
`;

export const TextWithProgress = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ProgressBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.4rem;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  background-color: ${({ theme }) => theme.colors.interactive.secondary};
  margin-left: 0.4rem;
`;

export const ProgressBar = styled.div`
  width: 1.6rem;
  height: 1.6rem;
  margin-right: 0.2rem;
`;
export const CustomAssetRow = styled(AssetRow)`
  .icon {
    margin-right: 0.4rem;
    max-width: 3.2rem;
    max-height: 3.2rem;
  }
  .asset-icon {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;
export const RecieveDetailsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  border-radius: ${({ theme }) => theme.borderRadius.x5};
  margin: 2.8rem 0;
`;
export const FooterDetailsWrapper = styled.div`
  margin-top: 1.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const DetailFieldsWrapper = styled.div`
  padding: 2rem;
`;
export const CustomButton = styled(Button)`
  width: fit-content;

  padding: 1rem;
`;
export const CustomTypography = styled(Typography)`
  padding-bottom: 1.6rem;
`;
export const CustomDisclaimer = styled(Disclaimer)`
  align-items: center;
  padding: 2rem 1.6rem;
  border-radius: ${({ theme }) => theme.borderRadius.x3};
  margin-top: 2.8rem;
  border: none;
  .icon {
    margin-top: 0;
  }
`;
export const CardIconWrapper = styled.div`
  margin-right: 1rem;
`;

export const AppleGooglePayWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const CustomIconPairWithDivider = styled(IconPairWithDivider)`
  margin-right: 1.8rem;
`;
